module.exports = __webpack_public_path__ + "img/fen.736eee30.png";